import "./src/styles/global.css";
import React, { useEffect } from "react";
import { Amplify } from "aws-amplify";
import awsconfig from "./src/aws-exports";
import { GrowthBookProvider } from "@growthbook/growthbook-react";
import growthbook from "./src/utils/growthbook";
import { InfoDialogProvider } from "./src/components/ui/InfoTextDialog";
import { DigitalProfileProvider } from "./src/context/DigitalProfileContext";
import { ReviewsProvider } from "./src/contexts/ReviewsContext";
import { ExitIntentProvider } from "./src/contexts/ExitIntentContext";
import { LanguageProvider } from "./src/contexts/LanguageContext";
import { TrackingParamsProvider } from "./src/contexts/TrackingParamsContext";
import { AffiliateTrackingProvider } from "./src/contexts/AffiliateTrackingContext";
import { version } from "./package.json";

Amplify.configure(awsconfig);

// Log version to console
console.log(`SimplyDebtSmart v${version}`);

// Helper function to get or create user ID cookie
function getClientId() {
  const cookieName = "client_id";
  const match = document.cookie.match(
    new RegExp("(^| )" + cookieName + "=([^;]+)"),
  );

  if (match) {
    return match[2];
  }

  // Generate new user ID
  const newClientId =
    "client_" +
    Math.random().toString(36).substring(2) +
    Date.now().toString(36);

  // Set cookie for 1 year
  const expires = new Date();
  expires.setFullYear(expires.getFullYear() + 1);
  document.cookie = `${cookieName}=${newClientId};expires=${expires.toUTCString()};path=/;SameSite=Lax`;

  return newClientId;
}

const GrowthBookWrapper = ({ children }) => {
  useEffect(() => {
    if (typeof window !== "undefined") {
      const clientId = getClientId();

      // Set user attributes for consistent experiment assignment
      growthbook.setAttributes({
        id: clientId,
        url: window.location.href,
        userAgent: navigator.userAgent,
      });

      // Initialize GrowthBook with streaming
      growthbook.init({ streaming: true });
    }
  }, []);

  return children;
};

export const wrapRootElement = ({ element }) => {
  return (
    <GrowthBookProvider growthbook={growthbook}>
      <GrowthBookWrapper>
        <TrackingParamsProvider>
          <AffiliateTrackingProvider>
            <LanguageProvider>
              <DigitalProfileProvider>
                <ExitIntentProvider>
                  <ReviewsProvider>
                    <InfoDialogProvider>{element}</InfoDialogProvider>
                  </ReviewsProvider>
                </ExitIntentProvider>
              </DigitalProfileProvider>
            </LanguageProvider>
          </AffiliateTrackingProvider>
        </TrackingParamsProvider>
      </GrowthBookWrapper>
    </GrowthBookProvider>
  );
};

// Admin routes are now protected by Cognito admin group membership
// No need for localhost restriction - auth check happens in the component
